import React, { Component } from "react";
import HomePage from "./HomePage";
import api from "../utility/api/api.js";
import { loginAction, getStoreAction } from "../actions/index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ListGroup, ListGroupItem } from "reactstrap";
import bmmilogo from "../images/bmmilogoImage.png";
import loader from "../images/loader.gif";

let clearIcon = {
  position: "absolute",
  top: "10px", // note the capital 'W' here
  right: "5px",
  background: "#9d959b",
  color: "#fff",
  padding: "0 8px",
  borderRadius: "50%",
  fontSize: "17px",
  // 'ms' is the only lowercase vendor prefix
};
let storeselect = {
  width: "100%",
  height: "40px",
  marginTop: "10px",
  backgroundColor: "white",
};
class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = { color: "light", isLoading: false };
    this.onSubmit = this.onSubmit.bind(this);
  }
  componentWillMount() {
    // const checkStoreData = api.getListOfStore(this);
    // console.log("checkStoreData", checkStoreData && checkStoreData);
  }

  async onSubmit(e) {
    e.preventDefault();
    // var select = document.getElementById("mySelect").selectedIndex;
    // var store_id = document.getElementsByTagName("option")[select].value;
    // let Store_id = store_id;
    this.setState({ isLoading: true });
    await api.callLoginApi(
      e.target.username.value,
      e.target.password.value,
      // Store_id,
      this
    );
    this.setState({ isLoading: false });
  }

  getColor(e) {
    if (e.target.id === "user") {
      this.setState({ color: "secondary" });
      e.target.value === "" ? this.setState({ color: "light" }) : "";
    }
    if (e.target.value.trim() !== "") {
      this.setState({ [e.target.id]: true });
    } else {
      this.setState({ [e.target.id]: false });
    }
  }
  clearInputField(id) {
    document.getElementById(id).value = "";
    this.setState({ [id]: false });
  }
  render() {
    let username = localStorage.getItem("user");
    if (!username) {
      return (
        <div className="col-md-4 cc col-sm-12 col-xs-12 form-container col-md-offset-3">
          <div className="logoContainer">
            <img className="bmmilogoImage" src={bmmilogo} />
            <span>
              Login to
              <br /> Rider App
            </span>
          </div>
          <form className="loginForm" name="loginForm" onSubmit={this.onSubmit}>
            <div className="form-group-collection">
              <ListGroup>
                <ListGroupItem
                  color={this.state.color}
                  className="p-0 username"
                >
                  <input
                    id="user"
                    placeholder="User name"
                    onChange={(e) => this.getColor(e)}
                    color="secondary"
                    className="input-text form-control"
                    type="text"
                    name="username"
                  />
                  {this.state.user ? (
                    <a
                      onClick={(e) => this.clearInputField("user")}
                      style={clearIcon}
                    >
                      x
                    </a>
                  ) : (
                    ""
                  )}
                </ListGroupItem>
                <ListGroupItem color="light" className="p-0 password">
                  <input
                    id="password"
                    placeholder="Password"
                    onChange={(e) => this.getColor(e)}
                    color="light"
                    className="input-text form-control"
                    type="password"
                    name="password"
                  />
                  {this.state.password ? (
                    <a
                      onClick={(e) => this.clearInputField("password")}
                      style={clearIcon}
                    >
                      x
                    </a>
                  ) : (
                    ""
                  )}
                </ListGroupItem>
              </ListGroup>
              {/* <div>
                <select style={storeselect} id="mySelect">
                  {this.props.storeData &&
                    this.props.storeData.items.map((value) => (
                      <option value={value.source_code}>{value.name}</option>
                    ))}
                </select>
              </div> */}
              <ListGroup>
                <ListGroupItem className="p-0 login-btn">
                  {this.state.isLoading ? (
                    <img src={loader} height="40px" />
                  ) : (
                    <input
                      type="submit"
                      className="btn btn-default"
                      value="Login"
                    />
                  )}
                </ListGroupItem>
              </ListGroup>
            </div>
            <div className="message"></div>
          </form>
        </div>
      );
    } else {
      return (
        <div>
          <HomePage />
        </div>
      );
    }
  }
}
function mapStateToProps(state) {
  return {
    login: state.login,
    storeData: state.getstoredata,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { loginAction: loginAction, getStoreAction: getStoreAction },
    dispatch
  );
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/LoginPage.js